import React from 'react';
import './Grid.css';

const Grid = ({ 
  children, 
  columns = 1,
  gap = 'medium',
  className = '',
  ...props 
}) => {
  const columnClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
    6: 'grid-cols-6',
    12: 'grid-cols-12'
  };

  const gapClasses = {
    none: 'gap-none',
    small: 'gap-small',
    medium: 'gap-medium',
    large: 'gap-large',
    xl: 'gap-xl'
  };

  const classes = [
    'grid',
    columnClasses[columns],
    gapClasses[gap],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Grid;
